import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=7779247a"
var script = {}
import style0 from "./terms.vue?vue&type=style&index=0&id=7779247a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports